var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetLayerFieldData, SetLayerFieldData } from './layer-field-data-service.interface';
import { LayerFieldInfoService } from './layer-field-info-service.interface';
import { Message } from '@patsnap/tahiti-core/common/message';
import { Logger } from '@patsnap/tahiti-core/common/logger';
//@ts-ignore
import { editFieldGlobalApi } from '@cores/apis/workspace_api/custom_field';
//@ts-ignore
import { i18nSymbol } from '@/i18n';
import { FieldEditorService } from '@/presentation/components/field-editor/field-editor-service.interface';
let LayerFieldServiceImp = class LayerFieldServiceImp {
    constructor(_layerFieldInfoService, _getLayerFieldData, _setLayerFieldData, _fieldEditorService, _message, _logger, _i18n) {
        this._layerFieldInfoService = _layerFieldInfoService;
        this._getLayerFieldData = _getLayerFieldData;
        this._setLayerFieldData = _setLayerFieldData;
        this._fieldEditorService = _fieldEditorService;
        this._message = _message;
        this._logger = _logger;
        this._i18n = _i18n;
    }
    async update() {
        const info = this._layerFieldInfoService.getLayerFieldInfo();
        const nodes = this._getLayerFieldData.getLayerFieldData();
        const resp = await editFieldGlobalApi({
            field_id: info.fieldId,
            field_color: info.fieldColor,
            field_name: info.fieldName,
            field_label_scope: info.fieldLabelScope,
            field_type: 'LAYER',
            // @ts-ignore todo
            field_layer_value: nodes,
            ignore_field_rule_setting: true,
        });
        const data = resp.field_layer_value;
        this._setLayerFieldData.setLayerFieldData(data);
        this._tryUpdateHsTableInstance(data);
        const message = this._i18n.t('fields.editCustomFieldOk');
        this._message.success({
            message,
        });
        this._logger.info(message);
        return data;
    }
    _tryUpdateHsTableInstance(data) {
        try {
            const { columns } = window.hsTableSettings || {};
            const column = columns.find(column => column.data === this._layerFieldInfoService.getLayerFieldInfo().fieldId);
            column._props.field_layer_value = data;
            if (window.hsTableInstance) {
                window.hsTableInstance.updateSettings({
                    columns,
                });
            }
        }
        catch (e) {
            this._logger.error(e);
        }
    }
};
LayerFieldServiceImp = __decorate([
    injectable(),
    __param(0, inject(LayerFieldInfoService)),
    __param(1, inject(GetLayerFieldData)),
    __param(2, inject(SetLayerFieldData)),
    __param(3, inject(FieldEditorService)),
    __param(4, inject(Message)),
    __param(5, inject(Logger)),
    __param(6, inject(i18nSymbol)),
    __metadata("design:paramtypes", [typeof (_a = typeof LayerFieldInfoService !== "undefined" && LayerFieldInfoService) === "function" ? _a : Object, typeof (_b = typeof GetLayerFieldData !== "undefined" && GetLayerFieldData) === "function" ? _b : Object, typeof (_c = typeof SetLayerFieldData !== "undefined" && SetLayerFieldData) === "function" ? _c : Object, typeof (_d = typeof FieldEditorService !== "undefined" && FieldEditorService) === "function" ? _d : Object, typeof (_e = typeof Message !== "undefined" && Message) === "function" ? _e : Object, typeof (_f = typeof Logger !== "undefined" && Logger) === "function" ? _f : Object, Object])
], LayerFieldServiceImp);
export { LayerFieldServiceImp };
